// extracted by mini-css-extract-plugin
export var container = "styles-module--container--rUwSH";
export var gridWrapper = "styles-module--gridWrapper--d1YEQ";
export var screenContainer = "styles-module--screenContainer--u+QTI";
export var screen = "styles-module--screen--FzQcb";
export var screenInfo = "styles-module--screenInfo--YKFM5";
export var screenInfoInner = "styles-module--screenInfoInner--k+a0O";
export var screenContent = "styles-module--screenContent--LW53F";
export var screenButton = "styles-module--screenButton--0zEAD";
export var linkButton = "styles-module--link-button--gxB6N";